import { ConfigTypes, getConfig } from 'projects/sharedComponents/src/services/getConfig/getConfig';

import { AccountDetails } from 'clientServerShared/types/account';
import { FlagshipVisitorContext } from '@flagship.io/js-sdk/dist/src';

type FlagshipProviderHooksReturn = {
  envId: string;
  apiKey: string;
  visitorContext: {
    id: string;
    isAuthenticated: boolean;
    context?: FlagshipVisitorContext;
  };
  hasUserLoaded: boolean;
};

export function useFlagshipProvider(accountDetails: AccountDetails): FlagshipProviderHooksReturn {
  return {
    envId: getConfig(ConfigTypes.FLAGSHIP_ENV_ID),
    apiKey: getConfig(ConfigTypes.FLAGSHIP_API_KEY),
    visitorContext: {
      id: accountDetails.user?.email ?? '',
      context: accountDetails.user?.permissions,
      isAuthenticated: !!accountDetails.user,
    },
    hasUserLoaded: !!accountDetails.user,
  };
}
